import getFetchWrapper from 'syf-api/api/getFetchWrapper';
import ENDPOINTS from '../../../const/endpoints';
const mutationFnFactory = (config, hasNewAuthorizedUser, keyProps) => {
    const fetchWrapper = getFetchWrapper(config);
    const isScopeCheckNeeded = !hasNewAuthorizedUser && {
        'X-SYF-Expect': '100-continue'
    };
    return ({ authorizedUsers }) => {
        const requestPayload = {
            'cipher.accountId': keyProps.accountId,
            accountIdType: keyProps.accountIdType,
            authorizedUsers
        };
        return fetchWrapper(ENDPOINTS.authorizedUsers, {
            method: 'POST',
            body: JSON.stringify(requestPayload),
            headers: {
                ...isScopeCheckNeeded
            }
        });
    };
};
export default mutationFnFactory;
